import { z } from 'zod';
import toast from 'react-hot-toast';

// Common validation schemas
export const schemas = {
  url: z.string().url("Please enter a valid URL"),
  // Add more schemas as needed
};

// Helper function to validate a value against a schema
export const validateField = async (value, schema) => {
  try {
    await schema.parseAsync(value);
    return { success: true };
  } catch (error) {
    if (error instanceof z.ZodError) {
      return { 
        success: false, 
        error: error.errors[0].message 
      };
    }
    return { 
      success: false, 
      error: "Validation failed" 
    };
  }
};

// Helper function that combines validation and toast
export const validateAndToast = async (value, schema) => {
  const result = await validateField(value, schema);
  if (!result.success) {
    toast.error(result.error);
  }
  return result.success;
};